import Vue from 'vue'

import withRender from './summary-dim-select.html'
import './summary-dim.scss'
import './summary-dim-select.scss'

export default withRender(Vue.extend({
  props: {
    label: { type: String },
    values: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    valueCounts() {
      return this.values.filter((item) => {
        return item.count > 0
      }).map((item) => {
        return `${item.label} (${item.count})`
      }).join(', ')
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-summary/summary-dim-select.ts